export default {
  toasts: {
    failed_to_save_changes: 'Muutosten tallennus epäonnistui.',
    successfully_saved: 'Tallennettu onnistuneesti.',
  },
  form: {
    has_multiple_locations: {
      label: 'Aseta eri sijainnit viikolle',
    },
  },
  labels: {
    day_location: '{{day}} sijainti {{index}}',
    selected_days: 'Valitut päivät',
    orders_paused: 'Tilaukset keskeytetty',
    open_time: 'Avausaika',
    close_time: 'Sulkemisaika',
  },
  buttons: {
    save: 'Tallenna',
  },
};
